"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function () {
    var device = virtual.device;
    var subDevice = virtual.subDevice;
    return {
        action: 'getTimerList',
        msgId: virtual.msgId,
        params: {
            devTid: device.devTid,
            subDevTid: subDevice.devTid ? [subDevice.devTid] : undefined,
            taskFormat: 'list',
            timeFormat: 'countdown'
        }
    };
}; });



// WEBPACK FOOTER //
// ./src/actions/send/actions/getTimerList.ts